import { render, staticRenderFns } from "./ItemsCreateDiscount.vue?vue&type=template&id=3b7d3791"
import script from "./ItemsCreateDiscount.vue?vue&type=script&lang=js"
export * from "./ItemsCreateDiscount.vue?vue&type=script&lang=js"
import style0 from "./ItemsCreateDiscount.vue?vue&type=style&index=0&id=3b7d3791&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports